import { makeQuery } from 'shared/utilities';
import { ICompanyBestDesignerModel } from "shared/models";

type ResponseType = {
    items: ICompanyBestDesignerModel[]
};

export const companyBestDesignerQuery = async () => {
    return await makeQuery<ResponseType>('/company-designer-groups');
}
